import { selectService, setEventScheduler, setScopeOfWork } from "../../../../redux/features/jobCreateSlice";
import { useAppDispatch } from "../../../../redux/hooks/redux";
import { useCallback } from "react";

export const useJobWizardHandlers = () => {
  const dispatch = useAppDispatch();

  const handleEventScheduler = useCallback((payload: any) => {
    dispatch(setEventScheduler(payload));
  }, [dispatch]);

  const handleScopeOfWork = useCallback((payload: any) => {
    dispatch(selectService(payload));
    dispatch(setScopeOfWork(payload));
  }, [dispatch]);

  return {
    handleEventScheduler,
    handleScopeOfWork,
  };
};
